// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess & { orderLines?: any[] }, CartLineCollectionModel, CartLineCollectionModel>;


export const XngPopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }
    // XNG-CHANGES: Allow passing orderlines as parameters
    let orderLines = order.value.orderLines
    if (props.parameter.orderLines) {
        orderLines = props.parameter.orderLines
    }

    props.apiParameter = {
        cartLines: orderLines!.map(
            (line: OrderLineModel) =>
            ({
                productId: line.productId,
                qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                unitOfMeasure: line.unitOfMeasure,
            } as CartLineModel),
        ),
    } as CartLineCollectionModel;
};


replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
